import Blue from "~/core";

new Blue({
	name: 'Alert Dismissal',
	selector: ".alert",
	setup(alert) {
		if (!window.sessionStorage.getItem("alertDismissed")) {
			alert.classList.remove("alert--hidden");
		}

		const dismissBtn = alert.querySelector(".alert__dismiss");

		const dismissAlert = () => {
			const start = alert.offsetHeight;
			alert.classList.add("alert--hidden");
			const end = alert.offsetHeight;
			alert.animate([
				{height: `${start}px`},
				{height: `${end}px`}
			], {
				duration: 350,
				easing: 'ease'
			});
		}

		this.$addEvents(dismissBtn, "click.prevent", () => {
			dismissAlert();
			window.sessionStorage.setItem("alertDismissed", true);
			const mobileMenuDrawer = document.querySelector(".header__mobile-drawer");
			mobileMenuDrawer.style.maxHeight = "";
		});
	}
});

new Blue({
	name: 'Alert Mobile Accordion',
	selector: ".alert",
	setup(alert) {
		const container = alert.querySelector(".alert__inner");
		const trigger = container.querySelector("button.alert__mobile-trigger");
		const content = container.querySelector(".alert__sub-content");

		const mobileMenuDrawer = document.querySelector(".header__mobile-drawer");
		const windowHeight = window.innerHeight;
		
		const setMobileDrawerHeight = () =>{ 
			if (window.innerWidth < 992)
				mobileMenuDrawer.style.maxHeight = windowHeight - mobileMenuDrawer.getBoundingClientRect().top + "px";
			else mobileMenuDrawer.style.maxHeight = "";
		}

		let config = {
			container,
			trigger,
			content,
		}
		let t = new this.$toggle(config);
		setMobileDrawerHeight();

		this.$addEvents(trigger, "click.prevent enter.prevent", () => {
			setTimeout(setMobileDrawerHeight, 310);
		});
	}
});